/*
 *
 * Vas
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 11-Dec-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  service: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.service' defaultMessage='VAS' />,
  status: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.status' defaultMessage='Status' />,
  action: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.action' defaultMessage='Action' />,
  close: <PortalMessage id='t.app.project.btn.close' defaultMessage='Close' />,
  done: <PortalMessage id='t.app.cta.result.done' defaultMessage='Done!' />,
  success: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.success' defaultMessage='Done!' />,
  failed: <PortalMessage id='t.app.project.popup.default.title.failure' defaultMessage='Failed!' />,
  subtitleFailure: (
    <PortalMessage
      id='t.app.terminalsManagement.vasConfiguration.failure'
      defaultMessage='Oops! An error has occurred'
    />
  ),
  successSubtitle: (
    <PortalMessage
      id='t.app.terminalsManagement.vasConfiguration.success.subtitle'
      defaultMessage='The configuration of the VAS was successful.'
    />
  )
}

export const messages = defineMessages({
  statusLabel_Enabled: { id: 't.app.terminalsManagement.vasConfiguration.status.enabled', defaultMessage: 'Enabled' },
  statusLabel_Disabled: {
    id: 't.app.terminalsManagement.vasConfiguration.status.disabled',
    defaultMessage: 'Disabled'
  },
  statusLabel_Error: {
    id: 't.app.terminalsManagement.vasConfiguration.status.error',
    defaultMessage: 'Error'
  },
  statusLabel_ActivationOnGoing: {
    id: 't.app.terminalsManagement.vasConfiguration.status.activationOnGoing',
    defaultMessage: 'Activation on going'
  },
  statusLabel_DeactivationOnGoing: {
    id: 't.app.terminalsManagement.vasConfiguration.status.deactivationOnGoing',
    defaultMessage: 'Deactivation on going'
  },
  cta_Enabled: {
    id: 't.app.terminalsManagement.vasConfiguration.action.manage',
    defaultMessage: 'Manage'
  },
  cta_Disabled: { id: 't.app.terminalsManagement.vasConfiguration.action.enable', defaultMessage: 'Enable' },
  emptyVas: {
    id: 't.app.terminalsManagement.vasConfiguration.emptyVas',
    defaultMessage: 'Attention, there are no VAS enabled for this terminal'
  }
})

export default formattedMessage
